import { RouterView, type RouterOptions } from "vue-router";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  formSubmissions: "FormSubmission.FormSubmissions",
  list: "FormSubmission.FormSubmissionList",
  base: "FormSubmission.FormSubmissionBase",
  view: "FormSubmission.FormSubmissionView",
  assignFormSubmission: "FormSubmission.AssignFormSubmission",
  update: "FormSubmission.EnterFormSubmissionReferenceNumber",
  drainageWellDimensions: "FormSubmission.FormSubmissionDrainageWellDimensions",
  drainageInjections: "FormSubmission.FormSubmissionDrainageInjections",
  generalWellDimensions: "FormSubmission.FormSubmissionGeneralWellDimensions",
  generalInjections: "FormSubmission.FormSubmissionGeneralInjections",
  abandonmentWellDimensions: "FormSubmission.FormSubmissionAbandonmentWellDimensions",
  abandonmentInjections: "FormSubmission.FormSubmissionAbandonmentInjections",
  abandonmentInjectionWells: "FormSubmission.FormSubmissionAbandonmentInjectionWells",
  existingWellDimensions: "FormSubmission.FormSubmissionExistingWellDimensions",
  existingInjections: "FormSubmission.FormSubmissionExistingInjections",
  drainageInjectionWellGeneralWellDimensions: "FormSubmission.FormSubmissionDrainageInjectionWellGeneralWellDimensions",
  drainageInjectionWellGeneralInjections: "FormSubmission.FormSubmissionDrainageInjectionWellGeneralInjections",
  existingDrainageInjectionWellWellDimensions:
    "FormSubmission.FormSubmissionExistingDrainageInjectionWellWellDimensions",
  existingDrainageInjectionWellInjections: "FormSubmission.FormSubmissionExistingDrainageInjectionWellInjections",
  injectionWellRenewalWellDimensions: "FormSubmission.FormSubmissionInjectionWellRenewalWellDimensions",
  injectionWellRenewalInjections: "FormSubmission.FormSubmissioninjectionWellRenewalInjections",
};

export { names as formSubmissionRouteNames };

const formSubmissionRoutes: RouterOptions["routes"] = [
  {
    path: "/formSubmission",
    name: names.formSubmissions,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: { title: "Form Submissions" },
        component: () => import("@/views/formSubmission/FormSubmissionList.vue"),
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/formSubmission/FormSubmissionBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Form Submission View" },
            component: () => import("@/views/formSubmission/FormSubmissionView.vue"),
          },
          {
            path: "assign",
            name: names.assignFormSubmission,
            meta: { title: "Assign Application", isForm: true },
            component: () => import("@/views/formSubmission/AssignFormSubmission.vue"),
          },
          {
            path: "update",
            name: names.update,
            meta: { title: "Form Submission Update", isForm: true },
            component: () => import("@/views/formSubmission/FormSubmissionUpdate.vue"),
          },
          {
            path: "drainage-injections",
            name: names.drainageInjections,
            meta: { title: "Form Submission Injection" },
            component: () => import("@/views/formSubmission/formChildLists/DrainageInjectionsChildList.vue"),
          },
          {
            path: "drainge-wells",
            name: names.drainageWellDimensions,
            meta: { title: "Form Submission Well Dimensions" },
            component: () => import("@/views/formSubmission/formChildLists/DrainageFormSubmissionWellDimensions.vue"),
          },
          {
            path: "general-injections",
            name: names.generalInjections,
            meta: { title: "Form Submission Injection" },
            component: () => import("@/views/formSubmission/formChildLists/GeneralInjectionsChildList.vue"),
          },
          {
            path: "general-wells",
            name: names.generalWellDimensions,
            meta: { title: "Form Submission Well Dimensions" },
            component: () => import("@/views/formSubmission/formChildLists/GeneralFormSubmissionWellDimensions.vue"),
          },
          {
            path: "abandonment-injections",
            name: names.abandonmentInjections,
            meta: { title: "Form Submission Injection" },
            component: () => import("@/views/formSubmission/formChildLists/AbandonmentInjectionsChildList.vue"),
          },
          {
            path: "abandonment-wells",
            name: names.abandonmentWellDimensions,
            meta: { title: "Form Submission Well Dimensions" },
            component: () =>
              import("@/views/formSubmission/formChildLists/AbandonmentFormSubmissionWellDimensions.vue"),
          },
          {
            path: "abandonment-injectionWells",
            name: names.abandonmentInjectionWells,
            meta: { title: "Form Submission Injection Wells to Abandon" },
            component: () => import("@/views/formSubmission/formChildLists/AbandonmentInjectionWellsChildList.vue"),
          },
          {
            path: "existing-injections",
            name: names.existingInjections,
            meta: { title: "Form Submission Existing Injection Well Application" },
            component: () => import("@/views/formSubmission/formChildLists/ExistingInjectionsChildList.vue"),
          },
          {
            path: "existing-wells",
            name: names.existingWellDimensions,
            meta: { title: "Form Submission Well Dimensions" },
            component: () => import("@/views/formSubmission/formChildLists/ExistingFormSubmissionWellDimensions.vue"),
          },
          {
            path: "drainageInjectionWellGeneral-injections",
            name: names.drainageInjectionWellGeneralInjections,
            meta: { title: "Form Submission Injection" },
            component: () =>
              import("@/views/formSubmission/formChildLists/DrainageInjectionWellGeneralInjectionsChildList.vue"),
          },
          {
            path: "drainageInjectionWellGeneral-wells",
            name: names.drainageInjectionWellGeneralWellDimensions,
            meta: { title: "Form Submission Well Dimensions" },
            component: () =>
              import("@/views/formSubmission/formChildLists/DrainageInjectionWellGeneralFormSubmissionWellDimensions.vue"),
          },

          {
            path: "existingDrainageInjectionWell-injections",
            name: names.existingDrainageInjectionWellInjections,
            meta: { title: "Form Submission Injection" },
            component: () =>
              import("@/views/formSubmission/formChildLists/ExistingDrainageInjectionWellInjectionsChildList.vue"),
          },
          {
            path: "existingDrainageInjectionWell-wells",
            name: names.existingDrainageInjectionWellWellDimensions,
            meta: { title: "Form Submission Well Dimensions" },
            component: () =>
              import("@/views/formSubmission/formChildLists/ExistingDrainageInjectionWellFormSubmissionWellDimensions.vue"),
          },

          {
            path: "injectionWellRenewal-injections",
            name: names.injectionWellRenewalInjections,
            meta: { title: "Form Submission Injection" },
            component: () =>
              import("@/views/formSubmission/formChildLists/InjectionWellRenewalInjectionsChildList.vue"),
          },
          {
            path: "injectionWellRenewal-wells",
            name: names.injectionWellRenewalWellDimensions,
            meta: { title: "Form Submission Well Dimensions" },
            component: () => import("@/views/formSubmission/formChildLists/InjectionWellRenewalWellDimensions.vue"),
          },
        ],
      },
    ],
  },
];
export default formSubmissionRoutes;
